import { CUSTOMER_LISTING_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { fetchCustomerCountSuccess, fetchCustomerCountFailure } from "./reducer"

export const fetchCustomerCount = (setLoading, tag) => async (dispatch) => {
    setLoading(true)
    const graphqlQuery = {
        query: "query customerTagStatusCount($tags: [String!]) {\n  customerTagStatusCount(tags: $tags) {\n    tag\n    activeCount\n inactiveCount }\n}",
        variables: { tags: [tag] },
    }

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            `${CUSTOMER_LISTING_API}`,
            'POST',
            graphqlQuery
        );
        setLoading(true)
        const customerTagCount = response?.data?.customerTagStatusCount
        dispatch(fetchCustomerCountSuccess(customerTagCount))
    } catch (error) {
        dispatch(fetchCustomerCountFailure(error.message))
    } finally {
        setLoading(false)
    }
}

